import { preparePayloadForGraphQL } from '@/helpers/validate';

/**
 * Field of the block project-invoice-approval ("Rechnungen: Freigabe") saved with its button, with
 * its payload type (`preparePayloadForGraphQL`). The state changes through its own action. Must
 * match `ProjectInvoiceApprovalInput` in the API schema; `createPayload` reuses the type.
 */
export const PROJECT_INVOICE_APPROVAL_FIELD_TYPES = {
  invoiceApprovementNote: 'string',
};

export const PROJECT_INVOICE_APPROVAL_INPUT_FIELDS = Object.keys(
  PROJECT_INVOICE_APPROVAL_FIELD_TYPES
);

/** `ProjectInvoiceApprovalInput` from the block object (or the unsaved project). */
export const toProjectInvoiceApprovalInput = (project) =>
  preparePayloadForGraphQL(project, PROJECT_INVOICE_APPROVAL_FIELD_TYPES);
